import { render, staticRenderFns } from "./BrandNewsEdit.vue?vue&type=template&id=26cd62bc&"
import script from "./BrandNewsEdit.vue?vue&type=script&lang=js&"
export * from "./BrandNewsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports